import React, { useMemo } from "react";
import { Tooltip, TooltipProps } from "@mui/material";

export const LightTooltip = React.memo(
  ({ children, ...props }: TooltipProps) => {
    const slotProps = useMemo(
      () => ({
        popper: { sx: { zIndex: 99999 } },
        tooltip: {
          sx: {
            bgcolor: "white",
            color: "black",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            "& .MuiTooltip-arrow": {
              color: "white",
              "&::before": {
                border: "1px solid #e0e0e0",
              },
            },
          },
        },
      }),
      []
    );

    return (
      <Tooltip arrow slotProps={slotProps} {...props}>
        {children}
      </Tooltip>
    );
  }
);

LightTooltip.displayName = "LightTooltip";
